import { PERSONALITY_TRAITS } from '@/lib/constants';

export default function TraitsPicker({ selected, onChange, max = 5, title, subtitle }) {
  const atMax = selected.length >= max;

  const toggle = (trait) => {
    if (selected.includes(trait)) {
      onChange(selected.filter(t => t !== trait));
    } else {
      if (atMax) return;
      onChange([...selected, trait]);
    }
  };

  const renderChip = (trait) => {
    const isSelected = selected.includes(trait);
    const isDimmed = atMax && !isSelected;

    let cls;
    if (isSelected) {
      cls = 'bg-[#C857A8] border-[#C857A8] text-white';
    } else {
      cls = 'bg-white border-[rgba(0,0,0,0.10)] text-[#1A1814]';
    }

    return (
      <button
        key={trait}
        onClick={() => toggle(trait)}
        disabled={isDimmed}
        style={{ minHeight: 36 }}
        className={`px-4 rounded-full border text-sm transition-colors ${cls} ${isDimmed ? 'opacity-40 cursor-default' : ''}`}
      >
        {trait}
      </button>
    );
  };

  return (
    <div>
      {title && <p className="text-sm font-semibold text-[#1A1814] mb-1">{title}</p>}
      {subtitle && <p className="text-xs text-[#7A7672] mb-3">{subtitle}</p>}

      <div className="flex flex-wrap gap-2 mb-4">
        {PERSONALITY_TRAITS.general.map(renderChip)}
      </div>

      <p className="text-[11px] uppercase tracking-wider text-[#C857A8] font-semibold mb-2">Jain values</p>
      <div className="flex flex-wrap gap-2 mb-3">
        {PERSONALITY_TRAITS.jain.map(renderChip)}
      </div>

      <p className={`text-xs font-medium ${selected.length === max ? 'text-[#C857A8]' : 'text-[#A8A5A0]'}`}>
        {selected.length}/{max} selected
      </p>
    </div>
  );
}
